import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../../axiosBaseQuery";


const BoreholeApi = createApi({
    reducerPath: "core/parameter/borhole/groundwater",
    baseQuery: axiosBaseQuery,
    tagTypes: ["parameterGroundwaterBorehole"],
    endpoints: (builder) =>({
        parameterGroundBoreholeFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['parameterGroundwaterBorehole'],
            query: (query = '') => ({
                url: "core/parameter/borhole/groundwater" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        parameterGroundBoreholeCreate: builder.mutation({
            invalidatesTags: ['parameterGroundwaterBorehole'],
            query: (data)=>({url: "core/parameter/borhole/groundwater", method: "POST", data})
        }),
        parameterGroundBoreholeUpdate: builder.mutation({
            invalidatesTags: ['parameterGroundwaterBorehole'],
            query: (data)=>({url: "/core/parameter/borhole/groundwater/"+data.id, method: "PUT", data})
        }),
    
        parameterGroundBoreholeDelete: builder.mutation({
            invalidatesTags: ['parameterGroundwaterBorehole'],
            query: (id)=>({url: "/core/parameter/borhole/groundwater/"+id, method: "DELETE"})
        }),
    })
})

export const { useParameterGroundBoreholeFindAllQuery, useParameterGroundBoreholeCreateMutation, useParameterGroundBoreholeUpdateMutation, useParameterGroundBoreholeDeleteMutation } = BoreholeApi;
export {BoreholeApi};
